import React from "react";

const TicketDetails = () => {
  return (
    <div className="w-[1014px] h-[590px] bg-[#FFF9F2] rounded-r-[10px] px-[32px] pt-[19px] pb-[45px]">
      <div className="w-[949px] h-[526px] rounded-[10px] bg-white drop-shadow-[0_0px_3px_rgba(0,0,0,0.10)] pt-[26px] pl-[26px] pr-[26px] pb-[72px] flex flex-col">
        <h3 className="w-[123px] h-[27px] font-semibold text-[18px] text-black text-start">
          Ticket Details
        </h3>

        <hr className="w-[206px] h-[2px] pb-[3px] bg-[#FF6300] rounded-full mt-[10px]" />

        <div className="flex justify-between mt-[22px]">
          <div className="flex flex-col h-[80px] justify-between">
            <p className="w-[60px] h-[21px] text-black text-start font-semibold text-[14px]">
              Ticket ID
            </p>
            <input
              type="text"
              placeholder="#12345"
              className="p-[12px] border rounded-[5px] w-[279px] h-[49px] placeholder:w-[255px] placeholder:h-[25px] placeholder:text-[14px] placeholder:font-medium font-medium text-[14px] text-black drop-shadow-[0_0px_1px_rgba(0,0,0,0.10)]"
            />
          </div>
          <div className="flex flex-col h-[80px] justify-between">
            <p className="w-[122px] h-[21px] text-black text-start font-semibold text-[14px]">
              Ticket Category
            </p>
            <input
              type="text"
              placeholder="Ticket Category 1"
              className="p-[12px] border rounded-[5px] w-[279px] h-[49px] placeholder:w-[255px] placeholder:h-[25px] placeholder:text-[14px] placeholder:font-medium font-medium text-[14px] text-black drop-shadow-[0_0px_1px_rgba(0,0,0,0.10)]"
            />
          </div>
          <div className="flex flex-col h-[80px] justify-between">
            <p className="w-[82px] h-[21px] text-black text-start font-semibold text-[14px]">
              Created On
            </p>
            <input
              type="text"
              placeholder="20/02/2024"
              className="p-[12px] border rounded-[5px] w-[279px] h-[49px] placeholder:w-[255px] placeholder:h-[25px] placeholder:text-[14px] placeholder:font-medium font-medium text-[14px] text-black drop-shadow-[0_0px_1px_rgba(0,0,0,0.10)]"
            />
          </div>
        </div>

        <div className="flex flex-col h-[167px] justify-between mt-[20px]">
          <p className="w-[82px] h-[21px] text-black text-start font-semibold text-[14px]">
            Description
          </p>
          <textarea
            name="TicketDescription"
            id="TicketDescription"
            rows={5}
            placeholder="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. "
            className="w-[900px] h-[136px] p-[12px] border rounded-[5px] placeholder:w-[876px] placeholder:h-[87px] placeholder:text-[14px] placeholder:font-medium font-medium text-[14px] text-black resize-none leading-[29px] drop-shadow-[0_0px_1px_rgba(0,0,0,0.10)]"
          ></textarea>
        </div>

        <div className="flex flex-col h-[78px] justify-between mt-[20px]">
          <p className="w-[94px] h-[21px] text-black text-start font-semibold text-[14px]">
            Attachments
          </p>
          <div className="w-[589px] h-[49px] flex flex-row items-center justify-between">
            <div className="py-[10px] px-[14px] w-[279px] h-[49px] rounded-[5px] border flex flex-row gap-x-[11px] items-center">
              <img
                src={require("../../../assets/BuyerProfile/Tickets/TicketDetails/image 131.jpg")}
                alt=""
                className="w-[22px] h-[28px]"
              />
              <p className="w-[68px] h-[21px] font-medium text-[14px] text-black">
                Issue.png
              </p>
            </div>

            <div className="py-[10px] px-[14px] w-[279px] h-[49px] rounded-[5px] border flex flex-row gap-x-[11px] items-center">
              <img
                src={require("../../../assets/BuyerProfile/Tickets/TicketDetails/image 131.jpg")}
                alt=""
                className="w-[22px] h-[28px]"
              />
              <p className="w-[68px] h-[21px] font-medium text-[14px] text-black">
                Issue.png
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TicketDetails;
